import state from './PaymentMethod/states'
import mutations from './PaymentMethod/mutations'
import actions from './PaymentMethod/actions'
import getters from './PaymentMethod/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
